import * as React from 'react';
// @tidal-export alias=./Story

import { Box, Paper, type SxProps, type Theme } from '@mui/material'
import { validateTidalLicense } from '@workwave-tidal/license-utils'
import type { ReactElement, ReactFragment } from 'react'

export type StoryProps = {
  children: ReactElement | string | number | ReactFragment | boolean | null | undefined
  elevation?: number
  sx?: SxProps<Theme>
}

export function Story(props: StoryProps) {
  const { children, elevation = 0, sx = {} } = props
  return (
    <Box data-testid="tidal-stories_story-wrapper" sx={{ width: '100%', flexGrow: 1, overflow: 'auto', padding: 1 }}>
      <Paper
        elevation={elevation}
        sx={{
          height: '100%',
        }}
      >
        <Box
          sx={{
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            padding: 2,

            ...sx,
          }}
        >
          {children}
        </Box>
      </Paper>
    </Box>
  )
}

// #license-validation
validateTidalLicense()
